import { NavLink, useNavigate } from "react-router-dom";
import s from "./confirm-phone-page.module.scss";
import { Controller, FormProvider, useForm } from "react-hook-form";
import ReactCodeInput from "react-code-input";
import { useEffect, useState } from "react";
import { CountdownTimer } from "@shared/ui/countdown-timer/countdown-timer";
import { Button } from '@shared/ui/button/button';
import { useProfile } from "@shared/api/useProfile";
import { auth } from "@shared/api/services";

const props = {
  className: s.inputsWrapper,
  inputStyle: {
    MozAppearance: "textfield",
    borderRadius: "0.5rem",
    border: "1px solid var(--border-default)",
    background: "var(--bg-elevated)",
    color: "var(--text-primary)",
    caretColor: "var(--color-primary-text)",
    fontSize: "2rem",
    padding: "1rem 0.75rem",
    paddingLeft: "0.75rem",
    width: 53,
    textAlign: "center",
  },
  inputStyleInvalid: {
    border: "1px solid #F12828",
  },
};

export const ConfirmPhone = () => {
  const methods = useForm({ mode: "onTouched" });
  const navigate = useNavigate();
	const [startTime, setStartTime] = useState(null)
	const [error, setError] = useState(null)
	const {data: profile, refetch} = useProfile()

  const [isExpired, setIsExpired] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const handleSubmit = methods.handleSubmit((data) => {
    const payload = {
      code: data?.code,
    };

    auth.phoneVerificationCode(payload).then((res) => {
      if (res.status === 200) {
				window.ym(96194074,'reachGoal','phone-verification')
        navigate("/");
				refetch()
      }
    }).catch(err => {
			if(err?.response?.data?.message){
				setError(err?.response?.data?.message)
			}
		});
  });


	useEffect(() => {
		if (profile) {
			if (!profile?.phone_verification_code_issued_at) {
				auth.requestPhoneVerificationCode().then(() => {
					refetch()
				})
			}
			setStartTime(profile?.phone_verification_code_issued_at)
			setButtonDisabled(false)
		}
	}, [profile, refetch])

	useEffect(() => {
		if (startTime) {
			setIsExpired(false)
		}
	}, [startTime])

  return (
    <div className={s.wrapper}>
      <div className={s.card}>
        <NavLink to={"/"} className={s.logo}>
          <img
            src={process.env.REACT_APP_STORAGE_URL + "images/logo.svg"}
            alt="Созвучно - сервис по поиску преподавателей музыки"
          />
        </NavLink>
        <h2 className={s.title}>Подтверждение телефона</h2>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit} className={s.form}>
						{error && <span className={s.error}>{error}</span>}
            <Controller
              name="code"
              control={methods.control}
              defaultValue=""
              rules={{
                required: "Введите код",
                pattern: {
                  value: /^\d{5}$/,
                  message: "Код должен состоять из 5 цифр",
                },
              }}
              render={({ field }) => (
                <ReactCodeInput
                  type="number"
                  fields={5}
                  {...field}
                  {...props}
                />
              )}
            />
            <div className={s.countdownWrapper}>
              {isExpired ? (
                <>
                  <button disabled={buttonDisabled} onClick={() => {
										setButtonDisabled(true)
										auth.requestPhoneVerificationCode().then(() => {
											refetch()
										}).finally(() => {
											setButtonDisabled(false)
										})}}>
                    Запросить код повторно
                  </button>
                </>
              ) : (
                <>
                  Повторно запросить код можно будет через:{" "}
                  {startTime && <CountdownTimer
                    durationInSeconds={300}
										timezone={profile?.timezone}
                    {...{ setIsExpired, startTime }}
                  />}
                </>
              )}
            </div>
            <Button
              label="Подтвердить"
              className={s.button}
              disabled={
                !methods?.formState?.isDirty || !methods?.formState?.isValid
              }
            />
          </form>
					<button className={s.logout} onClick={() => auth.logout()}>Выйти</button>
        </FormProvider>
      </div>
    </div>
  );
};
